// @ts-check
// ====== Safe HTML template tag ======
// Uso:
//   element.innerHTML = html`<div>${user.nome}</div>`;
// Tutti i valori interpolati vengono escapati automaticamente.
// Per inserire markup pre-validato, usare html.raw(...):
//   html`<ul>${html.raw(itemsHtml)}</ul>`
//
// Riduce il rischio XSS sui punti dove escapeHtml è dimenticato.

/**
 * @param {unknown} v
 * @returns {string}
 */
function escapeValue(v) {
  if (v == null) return '';
  if (v && typeof v === 'object' && /** @type {any} */ (v).__rawHtml === true) {
    return /** @type {any} */ (v).value;
  }
  if (Array.isArray(v)) return v.map(escapeValue).join('');
  return String(v).replace(
    /[&<>"']/g,
    (c) =>
      /** @type {Record<string,string>} */ ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[c]
  );
}

/**
 * Template tag function: html`<p>${x}</p>` -> stringa HTML safe.
 * @param {TemplateStringsArray} strings
 * @param  {...unknown} values
 * @returns {string}
 */
function html(strings, ...values) {
  let out = strings[0];
  for (let i = 0; i < values.length; i++) {
    out += escapeValue(values[i]) + strings[i + 1];
  }
  return out;
}

/**
 * Marca una stringa come "markup già sicuro": non verrà escapata.
 * Usare solo su HTML costruito a sua volta con html`...`.
 * @param {string} markup
 */
html.raw = function rawHtml(markup) {
  return /** @type {{__rawHtml: true, value: string}} */ ({
    __rawHtml: true,
    value: String(markup)
  });
};

// Espongo come globale per uso facile dai moduli legacy
// @ts-ignore
globalThis.html = html;
// @ts-ignore
globalThis.escapeValue = escapeValue;

export { html, escapeValue };
